import request from '@/utils/request'

/**
 * 分页统计IP访问频率
 * @param {Object} params { day, ipAddress, pageNum, pageSize }
 * @param {string}  params.day 统计日期 yyyy-MM-dd（为空汇总所有天）
 * @param {string}  params.ipAddress IP模糊匹配（可选）
 */
export function reqIpStatPage(params) {
    return request({
        url: '/system/sysIpStat/page',
        method: 'get',
        params
    })
}

/**
 * 保存/更新某IP的标签（如标记为本机）
 * @param {Object} data { ipAddress, labelName, remark }
 */
export function reqIpLabelSave(data) {
    return request({
        url: '/system/sysIpLabel/save',
        method: 'post',
        data
    })
}

/**
 * 取消某IP的标签
 * @param {string} ipAddress IP地址
 */
export function reqIpLabelDelete(ipAddress) {
    return request({
        url: `/system/sysIpLabel/delete/${ipAddress}`,
        method: 'delete'
    })
}

/**
 * 删除指定IP的访问频率统计及其对应的操作日志
 * @param {string} ipAddress IP地址
 */
export function reqIpStatDelete(ipAddress) {
    return request({
        url: `/system/sysIpStat/delete/${ipAddress}`,
        method: 'delete'
    })
}
